export default __webpack_public_path__ + "static/media/AHA-logo.4a553b55.svg";